(() => {
  const root = document.documentElement;
  const pendingClass = 'kfa-product-entry-pending';
  const readyClass = 'kfa-product-entry-ready';

  const readingPrototypeHandle = 'phantom-917';
  const readingPrototypeClass = 'kfa-reading-prototype';
  const readingVisibleClass = 'kfa-reading-story-visible';
  const readingStyleId = 'kfa-reading-prototype-style';

  const currentProductHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const readingPrototypeActive = currentProductHandle() === readingPrototypeHandle;

  const installReadingPrototype = () => {
    if (!readingPrototypeActive) return;
    root.classList.add(readingPrototypeClass);
    if (document.getElementById(readingStyleId)) return;

    const style = document.createElement('style');
    style.id = readingStyleId;
    style.textContent = `
html.kfa-reading-prototype .product-information__description,
html.kfa-reading-prototype .product-information__description + .toggle-link {
  opacity: 0 !important;
  transition: opacity 5s ease !important;
  will-change: opacity;
}
html.kfa-reading-prototype.kfa-reading-story-visible .product-information__description,
html.kfa-reading-prototype.kfa-reading-story-visible .product-information__description + .toggle-link {
  opacity: 1 !important;
}
`;
    document.head.appendChild(style);
  };

  let readingTimer = null;
  const startReadingPrototype = () => {
    if (!readingPrototypeActive) return;
    window.clearTimeout(readingTimer);
    root.classList.remove(readingVisibleClass);
    readingTimer = window.setTimeout(() => {
      root.classList.add(readingVisibleClass);
    }, 1500);
  };

  installReadingPrototype();

  const compactGermanDescriptionParagraphs = () => {
    if (!root.lang || !root.lang.toLowerCase().startsWith('de')) return;
    document.querySelectorAll('.product-information__description .origin').forEach((origin) => {
      const breaks = Array.from(origin.querySelectorAll('br'));
      breaks.forEach((firstBreak) => {
        if (!firstBreak.isConnected) return;
        let next = firstBreak.nextSibling;
        while (next && next.nodeType === Node.TEXT_NODE && next.textContent.trim() === '') next = next.nextSibling;
        if (next && next.nodeType === Node.ELEMENT_NODE && next.tagName === 'BR') {
          const gap = document.createElement('span');
          gap.className = 'kfa-description-paragraph-gap';
          gap.setAttribute('aria-hidden', 'true');
          gap.style.display = 'block';
          gap.style.height = '0.5rem';
          gap.style.pointerEvents = 'none';
          firstBreak.replaceWith(gap);
          next.remove();
        }
      });
    });
    window.dispatchEvent(new Event('resize'));
  };

  const revealPage = () => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const productInformation = document.querySelector('.product-information');
        if (productInformation) productInformation.dataset.kfaHeroReady = 'true';
        root.classList.remove(pendingClass);
        root.classList.add(readyClass);
        startReadingPrototype();
        window.setTimeout(() => root.classList.remove(readyClass), 800);
      });
    });
  };

  const waitForHeroImage = async () => {
    const heroImage = document.querySelector(
      '#MainContent .product-information slideshow-slide[aria-hidden="false"] .product-media__image, ' +
        '#MainContent .product-information slideshow-slide:first-of-type .product-media__image, ' +
        '#MainContent .product-information .product-media__image'
    );
    if (!heroImage) return;
    if (!heroImage.complete || heroImage.naturalWidth === 0) {
      await new Promise((resolve) => {
        const finish = () => resolve();
        heroImage.addEventListener('load', finish, { once: true });
        heroImage.addEventListener('error', finish, { once: true });
      });
    }
    if (heroImage.complete && heroImage.naturalWidth > 0 && typeof heroImage.decode === 'function') {
      try { await heroImage.decode(); } catch (error) {}
    }
  };

  const initialise = async () => {
    compactGermanDescriptionParagraphs();
    try {
      await Promise.race([
        waitForHeroImage(),
        new Promise((resolve) => window.setTimeout(resolve, 4500))
      ]);
    } finally {
      revealPage();
    }
  };

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      compactGermanDescriptionParagraphs();
      revealPage();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', compactGermanDescriptionParagraphs, { once: true });
  }

  initialise();
})();
